<template>
  <form class="t-reviewForm" @submit.stop.prevent="Submit()">
    <h2>{{ reviewText.title_1 }}</h2>
    <div class="t-input t-reviewForm__rate">
      <label>{{ reviewText.select }}</label>
      <span :class="{_opacity: rate === 0}">0</span><span :class="{_opacity: rate === 10}">10</span>
      <vue-slider v-model="rate" v-bind="options"></vue-slider>
    </div>
    <div class="t-input">
      <div v-for="(item, index) in radio.items" :key="'radio_' + index">
        <input type="radio" v-model="radio.value" :value="item.value" :id="'cause_' + index" class="t-radio">
        <label :for="'cause_' + index">{{ item.title }}</label>
      </div>
      <textarea v-model="text" :placeholder="reviewText.placeholder"></textarea>
    </div>
    <div class="t-reviewForm__buttons">
      <button class="t-btn" :class="{_disabled: disabledBtn}"><span>{{ reviewText.btnOk }}</span></button>
      <button class="t-btn t-btn_white" @click.prevent="modalDialogClose()"><span>{{ reviewText.cancel }}</span></button>
    </div>
  </form>
</template>

<script>
    import {store} from '../../store'
    import {mapGetters, mapActions} from 'vuex'
    import vueSlider from 'vue-slider-component'

    export  default {
        components: {
            vueSlider
        },
        data(){
            return {
                disabledBtn: false,
                options: {
                    width: "100%",
                    min: 0,
                    max: 10,
                    height: 11,
                    dotSize: 26,
                    bgStyle: {
                        "backgroundColor": "#ffffff",
                        "boxShadow": "0px 5px 20px rgba(0, 108, 202, 0.19)"
                    },
                    tooltipStyle: {
                        "backgroundColor": "transparent",
                        "color": "#59DCED",
                        "border": "none",
                        "padding": "0",
                        "fontSize": "36px",
                        "fontWeight": "bold",
                        "lineHeight": "43px"
                    },
                    processStyle: {
                        "backgroundColor": "#ffffff"
                    },
                    sliderStyle: {
                        "backgroundColor": "#ffffff",
                        "border": "5px solid #59DCED",
                        "boxShadow": "none"
                    }
                },
                rate: 0,
                radio: {
                    name: 'cause',
                    value: 1,
                    items: [
                        {
                            value: 1,
                            title: store.getters['staticText/reviewText'].cause[0],
                        },
                        {
                            value: 2,
                            title: store.getters['staticText/reviewText'].cause[1],
                        },
                        {
                            value: 3,
                            title: store.getters['staticText/reviewText'].cause[2],
                        },
                        {
                            value: 4,
                            title: store.getters['staticText/reviewText'].cause[3],
                        }
                    ]
                },
                text: ''
            }
        },
        computed: {
            ...mapGetters('coursesList', ['course', 'reviewId']),
            ...mapGetters('staticText',['reviewText'])
        },
        methods: {
            ...mapActions('modal', ['modalDialogClose']),
            ...mapActions('coursesList', ['LoadHistory']),
            ...mapActions('msg', ['showMsg']),
            Submit(){
                this.disabledBtn = true;

                let fd = new FormData();

                fd.append('lessonId', this.reviewId);
                fd.append('type', this.radio.value);
                fd.append('text', this.text);
                fd.append('rate', this.rate);

                this.$http.post('courses/' + this.course.id + '/reviews', fd)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success){
                            this.disabledBtn = false;

                            this.modalDialogClose();
                            this.showMsg(this.reviewText.msg2);
                            this.LoadHistory({id: this.course.id});
                        } else{
                            this.showMsg(data.errors.text[0])
                        }
                    })
                    .catch(error => {
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                    });
            }
        }
    }
</script>

<style lang="sass">
.t-reviewForm
  width: 304px
  padding: 24px
  @extend %substrate
  &__rate.t-input
    display: flex
    align-items: center
    justify-content: space-between
    flex-wrap: wrap
    label
      width: 100%
      flex: none
      margin-bottom: 45px
    > span
      font-size: 14px
      &._opacity
        opacity: 0
    .vue-slider-component
      width: 100%
      flex: none
  .t-input
    textarea
      height: 80px
    > div
      margin: 0 0 24px
  &__buttons
    display: flex
    align-items: center
    justify-content: space-between
    .t-btn
      width: auto
.vue-slider-component .vue-slider-tooltip-top .vue-merged-tooltip .vue-slider-tooltip:before, .vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-top .vue-slider-tooltip:before
  content: none!important
  display: none!important
.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-top
  top: 0!important
</style>


// WEBPACK FOOTER //
// src/vue_components/ModalDialog/Review.vue